<template>
  <div class="stats">
    <div class="stats-container">
      <Title
        :opponent="opponent"
        :unlocked="unlocked"
        state="close"
        @button-clicked="$emit('close-stats')"
      />
      <StatsHeader
        :opponent-header-stats="opponent.headerStats"
        :opponent-striking-accuracy="opponent.strikingAccuracy"
        :opponent-grappling-accuracy="opponent.grapplingAccuracy"
      />
      <Divider/>
      <Records
        :opponent-flag="opponent.flagImage"
        :opponent-rank="opponent.rank"
        :opponent-image="opponent.image3"
        :opponent-win-loss="opponent.winLossRatio"
        :opponent-total-fights="opponent.totalFights"
        :opponent-wins="opponent.wins"
        :opponent-losses="opponent.losses"
        :opponent-reach="opponent.reach"
        :opponent-mma-record="opponent.mmaRecord"
        :opponent-knockouts="opponent.knockouts"
        :opponent-background-colour="opponent.rankBackgroundColour"
        :opponent-text-colour="opponent.rankTextColour"
      />
      <Divider/>
      <Biography
        :opponent-hometown="opponent.hometown"
        :opponent-age="opponent.age"
        :opponent-height="opponent.height"
        :opponent-weight="opponent.weight"
      />
      <Divider/>
      <Story
        :opponent-story="opponent.story"
      />
      <Divider/>
      <Sponsor/>
    </div>
  </div>
</template>

<script>
import Title from '../../components/Title/Title'
import Divider from '../../components/Divider/Divider'
import Records from './partials/Records/Records'
import Biography from './partials/Biography/Biography'
import Story from './partials/Story/Story'
import StatsHeader from './partials/StatsHeader/StatsHeader'
import Sponsor from './partials/Sponsor/Sponsor'
import { calcFilteredAverages } from '@/utils/emotionSeriesUtils'
export default {
  components: {
    StatsHeader,
    Title,
    Records,
    Biography,
    Story,
    Divider,
    Sponsor
  },
  props: {
    opponent: {
      type: Object,
      required: true
    },
    unlocked: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    opponentEmotionAveragesFiltered () {
      return calcFilteredAverages(this.opponent.emotionSeries)
    }
  }
}
</script>

<style lang="scss" scoped>
.stats {
  width: 100%;
  padding-top: calc(var(--spacing-1) + 1rem);
  display: flex;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.7) 12rem, rgba(0, 0, 0, 0.7));
}
.stats-container {
  width: 100%;
  padding: var(--spacing-1) var(--spacing-1) calc(var(--spacing-1) * 2);
  display: flex;
  flex-direction: column;
  position: relative;
}
</style>
